import "./contact.css";

import React from "react";

import { BACKGROUNDS, CONTACT, CONTACT_DETAILS } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { PageLayout } from "../general/PageSections";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <PageLayout
      title={CONTACT.TITLE}
      background={BACKGROUNDS.CONTACT}
    >
      <PageMeta
        title={CONTACT.META_TITLE}
        description={CONTACT.DESCRIPTION}
      />
      <section className={"content-box contact"}>
        <div className={"contact-grid"}>
          <div className={"contact-details"}>
            <hr className={"rule"} />
            <h2 className={"contact-name"}>{CONTACT.NAME}</h2>
            <p>
              Tel:{" "}
              <a href={CONTACT_DETAILS.TEL.link}>{CONTACT_DETAILS.TEL.label}</a>
              <br />
              Cell:{" "}
              <a href={CONTACT_DETAILS.CELL.link}>{CONTACT_DETAILS.CELL.label}</a>
              <br />
              E-mail:{" "}
              <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
            </p>
            <p>
              <a
                href={CONTACT_DETAILS.MAP_LINK}
                target={"_blank"}
                rel={"noopener noreferrer"}
              >
                {CONTACT_DETAILS.ADDRESS.join("\n")}
              </a>
            </p>
          </div>
          <ContactForm successText={CONTACT.SUCCESS} />
        </div>

        <iframe
          className={"contact-map"}
          src={CONTACT_DETAILS.MAP_EMBED}
          title={"Map showing Candlewoods Guesthouse"}
          loading={"lazy"}
          referrerPolicy={"no-referrer-when-downgrade"}
        />
      </section>
    </PageLayout>
  );
};

export default Contact;
